import { render, staticRenderFns } from "./ISACloseFollowUpLicense.vue?vue&type=template&id=cefa96c8&scoped=true&"
import script from "./ISACloseFollowUpLicense.vue?vue&type=script&lang=js&"
export * from "./ISACloseFollowUpLicense.vue?vue&type=script&lang=js&"
import style0 from "./ISACloseFollowUpLicense.vue?vue&type=style&index=0&id=cefa96c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefa96c8",
  null
  
)

export default component.exports